import { DOCUMENT, inject } from '@angular/core'
import { HttpInterceptorFn } from '@angular/common/http'

const QA_STUBS_COOKIE = 'QA_STUBS'

const readCookie = (document: Document, name: string) => {
  const prefix = `${name}=`
  const cookie = document.cookie.split('; ').find(entry => entry.startsWith(prefix))

  if (!cookie) {
    return undefined
  }

  const value = cookie.slice(prefix.length)

  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

// The API lives on another domain and cookies are deliberately not sent cross-origin, so the QA stubs
// cookie reaches the backend as a `baggage` header instead.
export const qaBaggageInterceptor: HttpInterceptorFn = (request, next) => {
  const stubs = readCookie(inject(DOCUMENT), QA_STUBS_COOKIE)

  if (!stubs) {
    return next(request)
  }

  return next(request.clone({ setHeaders: { baggage: stubs } }))
}
